/**
 * 共享時間常數，供 timeout、delay、interval 等時間相關邏輯引用。
 * @external https://innotech.atlassian.net/browse/FE-8514 - 新增共享時間常數模組
 */
export const oneSecondToMilliseconds = 1000;

/**
 * HTTP client 預設逾時時間。
 * @external https://innotech.atlassian.net/browse/FE-8514 - 集中 http-client timeout 常數
 */
export const httpClientDefaultTimeoutMs = 20 * oneSecondToMilliseconds;

/**
 * Passkey platform API 請求逾時時間。
 * @external https://innotech.atlassian.net/browse/FE-8514 - 集中 passkey API timeout 常數
 */
export const passkeyPlatformRequestTimeoutMs = 20 * oneSecondToMilliseconds;

/**
 * Safari on Mac 回跳後延遲重載等待時間。
 * @external https://innotech.atlassian.net/browse/FE-8514 - 集中 Redirect 重載 delay 常數
 */
export const safariRedirectReloadDelayMs = oneSecondToMilliseconds;
